/**
 * 
 */
export class SbAdminDatatables {
	
	constructor() {
		this.datatables = [];
		this.currentTable = null;
	}
	
	init() {
		let app = this,
			$document = $(document);
		
		$('.js-data-table').each(function(i, table) {
			app.initDataTable($(table));
		});

		$document.on('click', 'tr a', function() {
			app.setClickedRow($(this));
		});
		
		$document.on('click', 'table.dataTable button.export-list', function (e) {
			e.preventDefault();
			app.exportTable($(this));
		});

		app.initUserActions();
	}

	//=====================================================================
	// Public
	//=====================================================================

	/**
	 * 
	 * @param id
	 * @returns {null|*}
	 */
	getTable(id) {
		if (id in this.datatables) {
			return this.datatables[id];
		}
		return null;
	}
	
	/**
	 * @param $table
	 * @param columns
	 */
	processDataTableFilters($table, columns) {
		var $filterRow = $table.find("tr.js-data-table-filter-columns");
		if ($filterRow.length > 0)
		{
			$.each($filterRow.children(), function (index, col) {
				if (index in columns) {
					var search = columns[index].search.search;
					if (search) {
						var $tmp,
							$col = $(col);

						// MULTISELECT
						$tmp = $col.find('select[multiple]');
						if ($tmp.length > 0) {
							$tmp.val(search.split("|"));
							if ($tmp.hasClass('js-whisperer-select'))
							{
								$tmp.trigger('change');
							}
							$tmp.addClass('column-filtered');
						} else {
							//MULTIPLE INPUTS
							$tmp = $col.find('input[data-other-field]');
							if ($tmp.length > 0) {
								var values = JSON.parse(search);
								if (values) {
									$tmp.each(function (i, e) {
										var $input = $(e);
										$input.val(values[$input.data('name')]);
										$input.addClass('column-filtered');
									});
								}
							} else {
								//Form controls
								$tmp = $col.find('input, select, textarea');
								if ($tmp.length > 0) {
									$tmp.val(search);
									$tmp.addClass('column-filtered');
								}
								//Parent
								else
								{
									$col.addClass('column-filtered');
									var $attrCol = $col.find('span');
									if ($attrCol.length) {
										var stToSearch = (search == '1') ? 1 : ((search == '0') ? 2 : "");

										$attrCol.data('setFilterState', stToSearch);
										$attrCol.attr('data-set-filter-state', stToSearch);
									}
								}
							}
						}
					}
				}
			});
		}
	}

	/**
	 * @param $table
	 */
	initDataTable($table) {
		var $document = $(document),
			app = this,
			source = $table.data('source'),
			sort = $table.data('defaultSort');

		var params = {
			"language": {
				"decimal":		",",
				"thousands":	"&nbsp;",
				"lengthMenu":	"Zobrazit _MENU_ záznamů",
				"zeroRecords":	"Nenalezeny žádné záznamy",
				"emptyTable":	"Nenalezeny žádné záznamy",
				"infoEmpty":	"Žádné záznamy",
				"info":			"Strana _PAGE_ / _PAGES_",
				"infoFiltered":	"",
				"infoPostFix":    "",
				"loadingRecords": "Načítám...",
				"processing":     "Zpracovávám...",
				"search":         "",
				"searchPlaceholder":         "Vyhledat:",
				"paginate": {
					"first":      "První",
					"last":       "Poslední",
					"next":       "Další",
					"previous":   "Předchozí"
				},
				"aria": {
					"sortAscending":  ": seřadit vzestupně",
					"sortDescending": ": seřadit sestupně"
				}
			},
			"scrollX": false,
			"lengthMenu": [10, 25, 50, 100, 500],
			"displayLength": $_defaultPagination,
			//"sorting": [[1,"desc"]],
			"orderCellsTop": true,
			"fixedHeader": true,
			"autoWidth": false,
			"stateSave": true,
			"stateLoadCallback": function(settings) {
				var data = JSON.parse(
					localStorage.getItem('DataTables_' + settings.sInstance +'_'+ window.location.pathname));
				if (data) {
					app.processDataTableFilters($table, data.columns);
				}
				return data;
			},
			"drawCallback": function() {
				window.setTimeout(function () {
					$customs.initBootstrapFeatures($table.find('tbody'));
					app.highlightSelectedRow($table.attr('id'));
				}, 500);
			},
			"createdRow": function( row, data, dataIndex ) {
				if ('row_class' in data) {
					$(row).addClass(data.row_class)
				}
				if ('row_id' in data) {
					$(row).attr('id', 'data-row-' + data.row_id);
				}
			},
			"order": sort ? sort.split(':') : [0,'asc'],
		};

		var $headCols = $table.find('.js-data-table-columns th'),
			columns = [];
		if ($headCols && $headCols.length)
		{
			$headCols.each(function (i, col) {
				var $col = $(col);
				columns.push({
					"name" : $col.data('columnFilter'),
					"data" : $col.data('column'),
					"orderable" : ($col.data('orderable') != undefined) ? $col.data('orderable') : "true",
					"className" : ($col.data('columnClass') != undefined) ? $col.data('columnClass') : null,
				});
			});

			params = Object.assign(params, {
				"columns": columns
			});
		}

		if (source)
		{
			params = Object.assign(params, {
				"serverSide": true,
				"ajax": {
					"url": source,
					"type": "POST",
					"dataSrc": "data"
				},
			});
		}

		var $footerSums = $table.find('.summaries');
		if ($footerSums.length > 0) {
			params.ajax = Object.assign(params.ajax, {
				"complete": function (response) {
					if (response.responseJSON
						&& ("sums" in response.responseJSON)) {
						$.each(response.responseJSON.sums, function (name, data) {
							$footerSums.find("#" + name).html(data);
						});
					}
				}
			});
		}

		if ($table.hasClass('nosearch'))
		{
			params = Object.assign(params, {
				"searching": false
			});
		}

		/*var customizeOptionsFunction = $table.data('customizeOptionsFunction');
		if (customizeOptionsFunction) {
			try {
				params = window[customizeOptionsFunction](params); 
			} catch (e) {
				console.error(e);
			}
		}*/

		this.currentTable = $table.DataTable(params);
		this.datatables[$table.attr('id')] = this.currentTable;

		$table.find("tr.js-data-table-filter-columns > td > input," +
			"tr.js-data-table-filter-columns > td > select," +
			"tr.js-data-table-filter-columns > td > .input-group > input").each(function (index, element) {
			app.dataTableApplyFilter(element, true);
		});
		this.currentTable.draw();

		//On filter change
		$document.on("keyup change",
			"tr.js-data-table-filter-columns > td > input," +
			"tr.js-data-table-filter-columns > td > select," +
			"tr.js-data-table-filter-columns > td > .input-group > input",
			function (e) {
				app.dataTableApplyFilter(this, false);
			});

		//Clear filters button
		$document.on('click', ".js-data-table-filter-columns button.clear-filters", function (e) {
			e.preventDefault();
			var $this = $(this),
				$tr = $this.closest('tr.js-data-table-filter-columns'),
				id = $this.closest('table').attr('id'),
				table = (id in app.datatables) ? app.datatables[id] : app.currentTable;
			$tr.find("td > input, td > select, td > .input-group > input")
				.val('')
				.trigger('change');

			$tr.find("td.attribute-column").each(function (i, el) {
				var $column = $(el),
					columnIndex = $column.index(),
					$icon = $column.find('span');
					$icon = $column.find('span');
				if (($icon.hasOwnProperty("data-set-filter-state"))
					|| ($icon.data('setFilterState') !== undefined)) {
					$icon.data('setFilterState', 0)
						.attr('data-set-filter-state', 0);
				}
				$column.removeClass('column-filtered');
				table.column(columnIndex)
					.search( "" );
			});
			table.order([0,'desc']);
			table.draw();
		});

		$table.find(".attribute-column > span").on('click', function () {
			var $icon = $(this);

			if (($icon.hasOwnProperty("data-set-filter-state"))
				|| ($icon.data('setFilterState') !== undefined)) {
				var $this = $(this),
					state = ((parseInt($icon.data('setFilterState')) + 1) % 3),
					id = $this.closest('table').attr('id'),
					table = (id in app.datatables) ? app.datatables[id] : app.currentTable;
				$icon.data('setFilterState', state);
				$icon.attr('data-set-filter-state', state);

				var $column = $icon.parent(),
					columnIndex = $column.index(),
					stToSearch = (state == 1) ? 1 : ((state == 2) ? 0 : "");

				table.column(columnIndex)
					.search(stToSearch)
					.draw();
				if (state) {
					$column.addClass('column-filtered');
				} else {
					$column.removeClass('column-filtered');
				}
			}
		});
	}

	//=====================================================================
	// Private
	//=====================================================================

	/**
	 *
	 * @param input
	 */
	dataTableApplyFilter(input, suppressDraw)
	{
		var $input = $(input),
			app = this,
			columnIndex = $input.closest('td').index(),
			value = $input.val(),
			id = $input.closest('table').attr('id'),
			table = (id in app.datatables) ? app.datatables[id] : app.currentTable;

		if (!value || (Array.isArray(value) && (value.length == 0))) {
			$input.removeClass('column-filtered');
		}
		else {
			if (Array.isArray(value)) {
				value = value.join("|");
			} else {
				var otherFieldId = $input.data('otherField'),
					$other = (otherFieldId) ? $(otherFieldId) : null;
				if ($other && ($other.length > 0)) {
					value = '{"' + $input.data('name') + '":"' + value + '",'
						+ '"' + $other.data('name') + '":"' + $other.val() + '"}';
					//e.preventDefault();
				}
			}
			$input.addClass('column-filtered');
		}

		if (table.column(columnIndex).search() !== value) {
			table.column(columnIndex)
				.search(value);
			if (!suppressDraw) {
				table.draw();
			}
		}
	}

	initUserActions() {
		$(document).on('click', ".dataTables_paginate > ul > li", function () {
			var tableId = $(this).attr('aria-controls');
			$("html, body").animate({ scrollTop: $('#' + tableId).offset().top }, 300);
		});
	}

	setClickedRow($a) {
		let $row = $a.closest('tr'),
			id = $row.attr('id');
		if (id && id.match(/^data-row-(\d+)$/)) {
			let tableId = $row.closest('table').attr('id');
			Cookies.set('datatables--' + tableId + '--uid', id);
		}
	}
	
	highlightSelectedRow(tableID) {
		const uid = Cookies.get('datatables--' + tableID + '--uid');
		const changedRow = $('#' + tableID + ' tbody tr#' + uid);
		if (uid)
		{
			changedRow.addClass('selected-row');
		}
		Cookies.remove('datatables--' + tableID + '--uid');
	}
	
	exportTable($button) {
		let app = this,
			id = $button.closest('table.dataTable').attr('id');
		if (id in app.datatables) {
			let table = app.datatables[id],
				url = table.ajax.url(),
				params = table.ajax.params();

			params.length = 1000;
			$.ajax({
				type: "POST",
				url: url,
				data: JSON.stringify(params),
				success(result) {
					app.createAndDownloadFile(params, result);
				},
				error(r) {
					console.error(r);
					toastr.error("Export se nezdařil");
				},
				dataType: "json",
				contentType: "application/json",
				timeout: 20000,
			});
		} else {
			toastr.error("Tabulka \"" + id + "\" nenalezena.");
			console.error('Data table "' + id + '" not found');
		}
	}
	
	createAndDownloadFile(params, data) {
		try {
			let text = '';
			let columns = [];
			//Print header
			$.each(params.columns, function (i, col) {
				if (('data' in col) && col.data !== "action") {
					let name = (col.data in $Lang.export.csvColumns) ? $Lang.export.csvColumns[col.data] : col.data;

					text += name + ";";
					columns.push(col.data);
				}
			});
			text += "\r\n";

			//Print data
			$.each(data.data, function (i, row) {
				for (let i = 0; i < columns.length; i++) {
					if (columns[i] in row) {
						if (columns[i].substr(0, 4) === "attr") {
							text += (row[columns[i]].length > 0) ? "ANO" : "NE";
						} else if (row[columns[i]]) {
							text += row[columns[i]].replace(/$\<[^\>]*\>/g, "").replace(/\<[^\>]*\>^/g, "").replace(/\<[^\>]*\>/g, " ");
						}
					}
					text += ";";
				}
				text += "\r\n";
			});


			//Prepare data for download
			const blob = new Blob([text], {type: 'text/plain'});
			const fileURL = URL.createObjectURL(blob);
			const downloadLink = document.createElement('a');
			downloadLink.href = fileURL;
			downloadLink.download = 'export.csv';
			//Add link to body
			document.body.appendChild(downloadLink);
			downloadLink.click();
			//Invalidate the link
			URL.revokeObjectURL(fileURL);
			//Delete the link
			window.setTimeout(function () {
				$(downloadLink).remove();
			}, 100);
		} catch (e) {
			console.error(e);
			toastr.error("Export se nezdařil");
		}
	}
}


//-----------------------------------------------------------------------------
// Datatables
//-----------------------------------------------------------------------------


//-----------------------------------------------------------------------------
// Hooks
//-----------------------------------------------------------------------------

window.$sbAdminDatatables = new SbAdminDatatables();

// Call the dataTables jQuery plugin
$(document).ready(function() {
	window.$sbAdminDatatables.init();

	$('select.select2').each(function(i, select) {
		var $select = $(select),
			options = {
				width: "100%",
			};
		if ($select.data('selectCss')) {
			options. containerCssClass = $select.data('selectCss');
		}
		$select.select2(options);
	});
});
